<template>
	<div class="journeys-skew-banner">
		<div class="container">
			<div class="row">
				<div class="col journeys-skew-banner__content text-center">
					<h1 class="h2">{{ microcopy?.heading }}</h1>
					<p>{{ microcopy?.summary }}</p>
				</div>
			</div>
		</div>
	</div>
	<div class="container pull-up">
		<form
			class="w-100"
			@submit.prevent
		>
			<div class="rounded-container">
				<div class="row">
					<div class="col d-flex flex-column flex-md-row rounded-container__btn-col">
						<RadioInputComponent
							v-for="label in labelText"
							:key="label"
							:options="label"
							:selected-option="selected"
							@selected="(payload) => {
								handleSelection(payload)
							}"
						/>
					</div>
				</div>
			</div>
			<div class="row btm-btn-group m-auto mb-5">
				<div class="col text-center">
					<GenericButton
						:label-text="progressionText"
						:button-disabled="!selected.selected"
						@button-click="handleClick"
					/>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import RadioInputComponent from '@/shared/components/RadioInputComponent.vue';
import GenericButton from '@/shared/components/GenericButton.vue';
import BackButton from '@/shared/components/BackButton.vue';
import router from '../router/index.js';

import { mapStores, mapActions, mapState } from 'pinia';
import { useAppointmentReferralStore } from '../stores/appointmentReferralStore.js';

export default {
	components: {
		RadioInputComponent,
		GenericButton,
		BackButton,
	},
	data() {
		return {
			selected: {},
			labelText: {
				newCustomer: {
					text: '',
				},
				existingCustomer: {
					text: '',
				},
			},
			progressionText: '',
			microcopy: ''
		};
	},
	computed: {
		...mapStores(useAppointmentReferralStore),
		...mapState(useAppointmentReferralStore, ['selectedCustomerType']),
		nextPage() {
			return this.selected.text === this.labelText.newCustomer.text ? 'know-your-fc' : 'details';
		},
	},
	methods: {
		...mapActions(useAppointmentReferralStore, ['postCustomerType', 'postFinancialAdviserCookie', 'postSelectedCustomerType']),
		handleClick() {
			this.postCustomerType(this.selected?.text?.includes('existing'));
			router.push(this.nextPage);
		},
		handleBackButton() {
			router.back();
		},
		handleSelection(payload) {
			this.selected = payload;
			this.postSelectedCustomerType(this.selected);
		},
		assignMicrocopyText() {
			this.labelText.newCustomer.text = this.microcopy?.newCustomerLabel;
			this.labelText.existingCustomer.text = this.microcopy?.existingCustomerLabel;
			this.progressionText = this.microcopy?.nextButtonLabel;
			document.title = this.microcopy?.metaTitle;
		}
	},
	mounted() {
		// cookie for checking if user has already completed the journey

		appInsights.trackTrace({
			message: '[BAARefJourney] API completed-already lookup - Started',
			properties: { area: 'appointment-referral-journey', hostname: location.hostname },
			severityLevel: 1
		});

		const options = {
			method: 'GET',
			headers: {
				'accept': 'application/json'
			}
		};

		fetch('/sapi/FinancialConsultants/financialConsultant', options)
			.then(async (res) => {
				if (!res.ok) {
					console.error(`Request failed with status ${res.status}`);
					appInsights.trackTrace({
						message: `[BAARefJourney] API completed-already lookup - Failed - received HTTP ${res.status}`,
						properties: { area: 'appointment-referral-journey', hostname: location.hostname },
						severityLevel: 4
					});

					document.cookie = `WesleyanFinancialConsultant=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${document.location.hostname};`;
					return;
				}

				if (res.status === 204) {
					appInsights.trackTrace({
						message: '[BAARefJourney] API completed-already lookup - Succeeded - received HTTP 204',
						properties: { area: 'appointment-referral-journey', hostname: location.hostname },
						severityLevel: 1
					});
					return;
				}

				appInsights.trackTrace({
					message: '[BAARefJourney] API completed-already lookup - Succeeded',
					properties: { area: 'appointment-referral-journey', hostname: location.hostname },
					severityLevel: 1
				});

				const data = await res.json();
				this.postFinancialAdviserCookie(data);

				return router.push('your-financial-adviser');
			})
			.catch((e) => {
				console.error(e);
				appInsights.trackTrace({
					message: `[BAARefJourney] API completed-already lookup - Failed - ${e}`,
					properties: { area: 'appointment-referral-journey', hostname: location.hostname },
					severityLevel: 4
				});
			});

		const storedSelection = this.selectedCustomerType;
		if (storedSelection) {
			this.selected = storedSelection;
		}
		this.microcopy = window.bookAnAppointmentReferralMicrocopy?.customerType;
		this.assignMicrocopyText();
		document.title = this.microcopy?.metaTitle
	},
};
</script>
